module.exports = __webpack_public_path__ + "4083f049cfc1ecc80dc54d86a570af3b.svg";